import React from 'react';
import { getClassNames } from './TopStripe.classNames';
import { Icon } from '../Icon';
import { UseScreen } from '../utils';
import classnames from 'classnames';
export const TopStripeUser = props => {
  const styles = getClassNames();
  const {
    name,
    showOnMobile = true,
    className
  } = props;
  const screenSize = UseScreen();

  if (screenSize.sm && !showOnMobile) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": 'topstripe-user',
    className: classnames(styles.topStripeUser, className)
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: "person"
  }), /*#__PURE__*/React.createElement("div", null, name));
};